import { CSSProperties } from "react";
import { CSSObject } from "styled-components";
import { FontWeight, TypographyVariant } from "./typography.types";

export const FONT_WEIGHT: Record<FontWeight, number> = {
    light: 300,
    regular: 400,
    strong: 600,
};

export const FONT_STYLE: Record<TypographyVariant, CSSProperties> = {
    h1: { fontSize: "3rem", lineHeight: "3.5rem" },
    h2: { fontSize: "2.5rem", lineHeight: "3.125rem" },
    h3: { fontSize: "2rem", lineHeight: "2.5rem" },
    h4: { fontSize: "1.375rem", lineHeight: "2rem" },
    body1: { fontSize: "1.125rem", lineHeight: "1.875rem" },
    body2: { fontSize: "1rem", lineHeight: "1.75rem" },
    body3: { fontSize: "0.875rem", lineHeight: "1.25rem" },
    body4: { fontSize: "0.75rem", lineHeight: "1.125rem" },
};

export function createTypographyStyle(typographyVariant: TypographyVariant, fontWeight: FontWeight, style: CSSObject = {}): CSSObject {
    return {
        ...FONT_STYLE[typographyVariant],
        fontFamily: "Montserrat",
        fontWeight: FONT_WEIGHT[fontWeight],
        ...style,
    };
}

export function createTypographyVariant(typographyVariant: TypographyVariant, fontWeight: FontWeight, style: CSSObject = {}) {
    return {
        component: typographyVariant[0] === "h" ? typographyVariant : "p",
        style: createTypographyStyle(typographyVariant, fontWeight, style),
    };
}

const typography = {
    h1Strong: createTypographyVariant("h1", "strong"),
    h1Regular: createTypographyVariant("h1", "regular"),
    h1Light: createTypographyVariant("h1", "light"),
    h2Strong: createTypographyVariant("h2", "strong"),
    h2Regular: createTypographyVariant("h2", "regular"),
    h2Light: createTypographyVariant("h2", "light"),
    h3Strong: createTypographyVariant("h3", "strong"),
    h3Regular: createTypographyVariant("h3", "regular"),
    h3Light: createTypographyVariant("h3", "light"),
    h4Strong: createTypographyVariant("h4", "strong"),
    h4Regular: createTypographyVariant("h4", "regular"),
    h4Light: createTypographyVariant("h4", "light"),
    body1Strong: createTypographyVariant("body1", "strong"),
    body1Regular: createTypographyVariant("body1", "regular"),
    body1Light: createTypographyVariant("body1", "light"),
    body2Strong: createTypographyVariant("body2", "strong"),
    body2Regular: createTypographyVariant("body2", "regular"),
    body2Light: createTypographyVariant("body2", "light"),
    body3Strong: createTypographyVariant("body3", "strong"),
    body3Regular: createTypographyVariant("body3", "regular"),
    body3Light: createTypographyVariant("body3", "light"),
    body4Strong: createTypographyVariant("body4", "strong"),
    body4Regular: createTypographyVariant("body4", "regular"),
    body4Light: createTypographyVariant("body4", "light"),
};

export default typography;
